(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-serum"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const setup = root => {
    if (instances.has(root)) return;
    const lifecycle = new AbortController();
    const signal = lifecycle.signal;
    const comparison = root.querySelector('[data-bas-comparison]');
    const range = root.querySelector('[data-bas-range]');
    const before = root.querySelector('.bas__label--before')?.textContent || 'Before';
    const update = value => {
      const position = Math.max(0, Math.min(100, Math.round(value)));
      range.value = String(position);
      range.setAttribute('aria-valuetext', `${before} ${position}%`);
      root.style.setProperty('--bas-position', `${position}%`);
    };
    range.addEventListener('input', () => update(Number(range.value)), { signal });
    let pointer = null;
    const move = event => {
      const bounds = comparison.getBoundingClientRect();
      if (bounds.width) update((event.clientX - bounds.left) / bounds.width * 100);
    };
    comparison.addEventListener('pointerdown', event => {
      if (event.button !== 0 || event.target === range) return;
      pointer = event.pointerId;
      comparison.setPointerCapture(pointer);
      range.focus({ preventScroll: true });
      move(event);
    }, { signal });
    comparison.addEventListener('pointermove', event => { if (pointer === event.pointerId) move(event); }, { signal });
    const stop = event => { if (pointer === event.pointerId) pointer = null; };
    comparison.addEventListener('pointerup', stop, { signal });
    comparison.addEventListener('pointercancel', stop, { signal });
    comparison.addEventListener('lostpointercapture', stop, { signal });
    const slides = [...root.querySelectorAll('[data-bas-slide]')];
    const dots = [...root.querySelectorAll('[data-bas-dot]')];
    const status = root.querySelector('[data-bas-status]');
    let current = 0;
    let motion;
    const show = (index, announce = true) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      motion?.cancel();
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-pressed', String(i === current));
      });
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        motion = slides[current].animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 260, easing: 'ease-out' });
      }
      if (announce) status.textContent = `${slides[current].querySelector('.bas__product-title').textContent}, ${current + 1} / ${slides.length}`;
    };
    root.querySelector('[data-bas-prev]')?.addEventListener('click', () => show(current - 1), { signal });
    root.querySelector('[data-bas-next]')?.addEventListener('click', () => show(current + 1), { signal });
    dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.basDot)), { signal }));
    const selectBlock = event => {
      const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
      if (index >= 0) show(index, false);
    };
    root.addEventListener('shopify:block:select', selectBlock, { signal });
    update(Number(range.value));
    instances.set(root, () => { motion?.cancel(); lifecycle.abort(); });
  };
  const init = scope => {
    if (scope.matches?.('[data-bas]')) setup(scope);
    scope.querySelectorAll('[data-bas]').forEach(setup);
  };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => {
      if (event.target === root || event.target.contains(root)) { destroy(); instances.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.SkincareParallaxV2) { window.SkincareParallaxV2.init(document); return; }
  const instances = new Map();
  class Motion {
    constructor(root) {
      this.root = root;
      this.items = [...root.querySelectorAll('[data-speed]')];
      this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.visible = false;
      this.value = null;
      this.tick = this.tick.bind(this);
      this.refresh = () => {
        this.value = null;
        this.paint();
        this.start();
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.start(); else this.stop();
      }, { rootMargin: '150px' });
      this.observer.observe(root);
      this.media.addEventListener('change', this.refresh);
      window.addEventListener('resize', this.refresh);
      this.paint();
    }
    enabled() { return this.root.dataset.motion === 'true' && !this.media.matches; }
    start() { if (this.visible && this.enabled() && !this.frame) this.frame = requestAnimationFrame(this.tick); }
    stop() { cancelAnimationFrame(this.frame); this.frame = 0; this.lastTime = null; }
    tick(time) {
      this.frame = 0;
      if (!this.root.isConnected) { this.destroy(); instances.delete(this.root); return; }
      const dt = this.lastTime ? Math.min(64, time - this.lastTime) : 16;
      this.lastTime = time;
      this.paint(dt);
      this.start();
    }
    paint(dt = 16) {
      const rect = this.root.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      // Follow the entire passage through the viewport, including entry.
      const target = Math.max(-1, Math.min(1, (viewport - 2 * rect.top - rect.height) / (viewport + rect.height)));
      this.value = this.value === null ? target : this.value + (target - this.value) * (1 - Math.exp(-dt / 70));
      const strength = this.enabled() ? (Number(this.root.dataset.strength) || 0) / 100 : 0;
      const scale = window.innerWidth < 750 ? 1.1 : 2.08;
      this.items.forEach(item => {
        const y = window.innerWidth < 750 && item.classList.contains('skp__card') ? 0 : this.value * Number(item.dataset.speed || 0) * strength * scale;
        const angle = this.value * Number(item.dataset.turn || 0) * strength;
        // Inline transform also prevents theme animation rules overriding the parallax.
        item.style.setProperty('transform', `translate3d(0,${y.toFixed(3)}px,0) rotate(${angle.toFixed(3)}deg)`, 'important');
      });
    }
    destroy() {
      this.stop(); this.observer.disconnect();
      this.media.removeEventListener('change', this.refresh);
      window.removeEventListener('resize', this.refresh);
    }
  }
  function fillDescriptions(scope) {
    scope.querySelectorAll('[data-skp-summary]').forEach(node => {
      const text = (node.dataset.description || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      let sentences;
      try {
        sentences = Array.from(new Intl.Segmenter(document.documentElement.lang || 'en', { granularity: 'sentence' }).segment(text), part => part.segment.trim());
      } catch (_) {
        sentences = text.match(/[^.!?]+[.!?]+(?:["”’])?|[^.!?]+$/g) || [text];
      }
      let result = sentences[0] || text;
      if (sentences[1] && (result + ' ' + sentences[1]).length <= 190) result += ' ' + sentences[1];
      if (result.length > 190) {
        const short = result.slice(0, 187);
        const boundary = short.lastIndexOf(' ');
        result = short.slice(0, boundary > 100 ? boundary : short.length).replace(/[,;:]$/, '') + '…';
      }
      node.textContent = result;
    });
  }
  function init(scope) {
    fillDescriptions(scope);
    const roots = [...scope.querySelectorAll('[data-skp]')];
    if (scope.matches && scope.matches('[data-skp]')) roots.unshift(scope);
    roots.forEach(root => { if (!instances.has(root)) instances.set(root, new Motion(root)); });
  }
  window.SkincareParallaxV2 = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((motion, root) => {
      if (root === event.target || event.target.contains(root)) { motion.destroy(); instances.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                input: this.querySelector(
                    'input[name="locale_code"], input[name="country_code"]'
                ),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            this.elements.button.addEventListener(
                'click',
                this.openSelector.bind(this)
            );
            this.elements.button.addEventListener(
                'focusout',
                this.closeSelector.bind(this)
            );
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

            this.querySelectorAll('a').forEach((item) =>
                item.addEventListener('click', this.onItemClick.bind(this))
            );
        }

        hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
        }

        onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;

            this.hidePanel();
            this.elements.button.focus();
        }

        onItemClick(event) {
            event.preventDefault();
            this.elements.input.value = event.currentTarget.dataset.value;
            this.querySelector('form')?.submit();
        }

        openSelector() {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute(
                'aria-expanded',
                (
                    this.elements.button.getAttribute('aria-expanded') === 'false'
                ).toString()
            );
        }

        closeSelector(event) {
            const shouldClose =
                event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.hidePanel();
            }
        }
    }

    if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
	super();
}

connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.header1 = document.querySelector('.header-wrapper--under-menu')
	this.header_wrapper = document.querySelector('.header-wrapper');
	this.header__offcanvas_menu = document.querySelector('.header__offcanvas-menu');
	this.predictiveSearch = this.querySelector('predictive-search');
	this.headerBounds = {};
	this.currentScrollTop = 0;

	this.onScrollHandler = this.onScroll.bind(this);

	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
}

disconnectedCallback() {
	window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
});

	observer.observe(this.header);
}

onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	if (window.innerWidth < 1100 && this.header.querySelector('header-drawer > details[open]')) {
		this.currentScrollTop = scrollTop;
		return;
	}

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
		this.predictiveSearch.onFocusOut();
		this.predictiveSearch.onBlur();
	} 
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
	} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
}

	hide() {
		if(this.header1){
			this.header.classList.add('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		}
		else {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}
	// this.closeSearchModal();
}

reveal() {
	if(this.header1){
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-fixed-hidden');
			this.header_wrapper.classList.add('header-wrapper--under-menu-full');
		}
	else {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
	}
	this.header__offcanvas_menu.classList.add('header__offcanvas_menu-reveal')
}

reset() {
	if(this.header1){
		this.header.classList.remove('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		this.header_wrapper.classList.remove('header-wrapper--under-menu-full');
	}
	else {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}
	this.header__offcanvas_menu.classList.remove('header__offcanvas_menu-reveal')

}

closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure?.close());
}

// closeSearchModal() {
// 	this.searchModal = this.searchModal || this.header.querySelector('details-modal');
// 	this.searchModal.close(false);
// }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-card"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-ic-mobile]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const rail = root.querySelector('[data-ic-rail]');
      const cards = [...root.querySelectorAll('[data-ic-card]')];
      const dots = [...root.querySelectorAll('[data-ic-dot]')];
      const go = index => {
        const card = cards[index];
        if (!card) return;
        rail.scrollBy({left: card.getBoundingClientRect().left - rail.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      let frame = 0;
      rail.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const left = rail.getBoundingClientRect().left;
          let active = 0, distance = Infinity;
          cards.forEach((card, i) => {
            const current = Math.abs(card.getBoundingClientRect().left - left);
            if (current < distance) { distance = current; active = i; }
          });
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
        });
      }, {passive:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}
	hide() {
		super.hide();
		window.pauseAllMedia();
	}
	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}
	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();
  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);
  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };
  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}
  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natura-bestsellers-portrait"] && !Shopify.designMode) return;
  try {
    
/* Natura Bestsellers v6: viewport-height pin, keeping the complete hero visible while the
   page scroll advances only the two product columns. No wheel hijacking.
   Portaling ONCE avoids sticky clipping by animated theme ancestors. */
if (!customElements.get('natura-portrait-viewport-pinned-v6')) {
  customElements.define('natura-portrait-viewport-pinned-v6', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      this.lifecycle?.abort();
      this.lifecycle = null;
      this.observer?.disconnect();
      // Restore original DOM order before removing our fixed overlay.
      this.restoreTrack();
      this.portal?.remove();
      this.portal = null;
      this.quickModals?.forEach(modal => {
        if (modal.parentNode === document.body) {
          if (modal.hasAttribute('open') && typeof modal.hide === 'function') modal.hide(true);
          modal.remove();
        }
      });
    }
    init() {
      if (this.lifecycle || !this.isConnected) return;
      this.track = this.querySelector('.nbp-grid');
      this.cards = [...this.querySelectorAll('.nbp-card')];
      this.stage = this.querySelector('.nbp-stage-slot');
      this.hero = this.querySelector('.nbp-hero');
      if (!this.track || !this.stage || !this.hero) return;
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.updatePortrait();
        });
      };
      document.addEventListener('scroll', this.schedule, {capture: true, passive: true, signal});
      window.addEventListener('resize', this.schedule, {passive: true, signal});
      window.visualViewport?.addEventListener('resize', this.schedule, {passive: true, signal});
      this.quickModals = [...this.querySelectorAll('quick-add-modal')];
      this.track.addEventListener('click', async event => {
        const button = event.target.closest('[data-nbp-quick]');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const modal = document.getElementById(button.dataset.nbpQuick);
        if (!modal) return;
        if (!customElements.get('quick-add-modal')) await customElements.whenDefined('quick-add-modal');
        if (!button.isConnected || !modal.isConnected) return;
        if (modal.parentNode !== document.body) document.body.append(modal);
        if (typeof modal.show === 'function') await modal.show(button);
      }, {capture: true, signal});
      this.track.addEventListener('click', event => {
        const button = event.target.closest('[data-nbp-direction]');
        if (!button || button.disabled || !this.cards.length) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 14;
        this.track.scrollBy({
          left: Number(button.dataset.nbpDirection) * (this.cards[0].getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }, {signal});
      this.track.addEventListener('scroll', () => this.sync(), {passive: true, signal});
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.nbp-card');
        if (card && window.innerWidth <= 749) {
          this.track.scrollTo({left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'auto'});
        }
      }, {signal});
      this.observer = new ResizeObserver(() => { this.sync(); this.schedule(); });
      this.observer.observe(this.hero);
      this.sync();
      this.updatePortrait();
    }
    createPortal() {
      if (!this.portal) {
        this.portal = document.createElement('div');
        this.portal.id = this.id.replace('natura-portrait-', 'natura-portrait-overlay-');
        const scope = document.createElement('div');
        scope.className = 'nbp';
        scope.style.display = 'contents';
        this.portal.append(scope);
        document.body.append(this.portal);
        this.portalScope = scope;
      }
      // Move only when crossing the desktop breakpoint, never when scrolling.
      if (this.track.parentNode !== this.portalScope) this.portalScope.append(this.track);
    }
    restoreTrack() {
      if (this.track && this.stage && this.track.parentNode !== this.stage) {
        this.stage.append(this.track);
      }
      if (this.track) {
        ['position', 'top', 'left', 'width', 'z-index', '--nbp-card-height'].forEach(
          name => this.track.style.removeProperty(name));
      }
    }
    sync() {
      if (!this.track) return;
      const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.track.querySelectorAll('[data-nbp-direction]').forEach(button => {
        button.disabled = Number(button.dataset.nbpDirection) < 0
          ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= end - 2;
      });
    }
    updatePortrait() {
      if (!this.stage || !this.track || !this.hero) return;
      if (window.innerWidth <= 749) {
        this.restoreTrack();
        this.portal?.remove();
        this.portal = null;
        this.portalScope = null;
        this.stage.style.removeProperty('height');
        this.cards.forEach(card => card.style.removeProperty('transform'));
        return;
      }

      // The stage stays in normal document flow and reserves exactly the time
      // needed to display all rows, regardless of scroll direction.
      const rect = this.stage.getBoundingClientRect();
      if (rect.width < 1) return;
      this.createPortal();
      const trackStyle = this.track.style;
      trackStyle.position = 'fixed';
      trackStyle.zIndex = '5';
      trackStyle.left = rect.left + 'px';
      trackStyle.width = rect.width + 'px';
      const trackCSS = getComputedStyle(this.track);
      const gap = parseFloat(trackCSS.columnGap) || 34;
      const rowGap = parseFloat(trackCSS.rowGap) || 20;
      const cardHeight = ((rect.width - 2 * gap) / 4) * 1.2;
      const oldHeight = parseFloat(trackStyle.getPropertyValue('--nbp-card-height'));
      if (!Number.isFinite(oldHeight) || Math.abs(oldHeight - cardHeight) > .5) {
        trackStyle.setProperty('--nbp-card-height', cardHeight + 'px');
      }
      const heroHeight = this.hero.offsetHeight;
      if (heroHeight < 1) return;
      const rows = Math.max(2, Math.ceil(this.cards.length / 2));
      const travel = Math.max(0, rows * cardHeight + (rows - 1) * rowGap - heroHeight);
      const slow = Math.max(1, Number(this.dataset.scrollDistance) || 2.5);
      const scrollLength = travel * slow;
      const desiredStageHeight = heroHeight + scrollLength;
      if (Math.abs(this.stage.offsetHeight - desiredStageHeight) > 1) {
        this.stage.style.height = desiredStageHeight + 'px';
      }

      // Pin the entire section as soon as the hero fully fills the available
      // viewport. The previous 900px cap and 90vh lock point caused blank
      // bands at non-100% browser zoom and on taller desktop viewports.
      // Section padding remains the only visible gap and is editor-controlled.
      const stageRect = this.stage.getBoundingClientRect();
      const headerOffset = Math.max(0, Number(this.dataset.stickyTop) || 0);
      const sectionTopPadding = parseFloat(getComputedStyle(this).paddingTop) || 0;
      const lockTop = headerOffset + sectionTopPadding;
      const pinnedTop = Math.min(
        Math.max(stageRect.top, lockTop),
        stageRect.bottom - heroHeight
      );
      trackStyle.top = pinnedTop + 'px';

      // The pin position and card progress use the SAME start line.
      // Any subsequent page scroll advances the side cards immediately;
      // reverse scrolling rewinds them without moving the portrait.
      const advanced = Math.max(0, Math.min(scrollLength, lockTop - stageRect.top));
      const productOffset = -Math.min(travel, advanced / slow);
      this.cards.forEach(card => {
        card.style.transform = 'translate3d(0,' + productOffset + 'px,0)';
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natura-social-devices"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initRoot = root => {
  if (!root || root.dataset.nssReady) return;
  root.dataset.nssReady = 'true';
  const lifecycle = new AbortController();
  const signal = lifecycle.signal;
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const labels = {play:root.dataset.playLabel,pause:root.dataset.pauseLabel,soundOn:root.dataset.soundOnLabel,soundOff:root.dataset.soundOffLabel,error:root.dataset.errorLabel};
  const items = [...root.querySelectorAll('[data-nss-device]')].map(device => ({device,video:device.querySelector('video'),toggle:device.querySelector('[data-nss-toggle]'),sound:device.querySelector('[data-nss-sound]'),status:device.querySelector('[data-nss-media-status]'),visible:false,userPaused:false})).filter(item => item.video);
  const attemptPlay = item => {
    if (item.video.readyState === 0) item.video.preload = 'metadata';
    const promise = item.video.play();
    promise?.catch(() => { item.device.classList.remove('is-playing'); });
  };
  const auto = item => root.dataset.autoplay === 'true' && !media.matches && !item.userPaused && !document.hidden && item.visible;
  items.forEach(item => {
    const {video,device,toggle,sound,status} = item;
    video.muted = true;
    const sync = () => {
      device.classList.toggle('is-playing', !video.paused);
      toggle.setAttribute('aria-label', `${video.paused ? labels.play : labels.pause} — ${device.dataset.platform}`);
      sound.setAttribute('aria-pressed', String(!video.muted));
      sound.setAttribute('aria-label', video.muted ? labels.soundOn : labels.soundOff);
    };
    video.addEventListener('play', sync, {signal});
    video.addEventListener('pause', sync, {signal});
    video.addEventListener('volumechange', sync, {signal});
    video.addEventListener('error', () => {status.textContent = labels.error; device.classList.remove('is-playing');}, {signal});
    toggle.addEventListener('click', () => {
      if (video.paused) {item.userPaused = false; attemptPlay(item);}
      else {item.userPaused = true; video.pause();}
    }, {signal});
    sound.addEventListener('click', () => {
      const enable = video.muted;
      if (enable) items.forEach(other => {if (other !== item) other.video.muted = true;});
      video.muted = !enable;
      if (enable && video.paused) {item.userPaused = false;attemptPlay(item);}
    }, {signal});
    sync();
  });
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const item = items.find(item => item.device === entry.target);
      if (!item) return;
      item.visible = entry.isIntersecting;
      if (auto(item)) attemptPlay(item);
      else if (!item.visible) {item.video.pause();item.video.muted = true;}
    });
  }, {threshold:.25});
  items.forEach(item => observer.observe(item.device));
  const refresh = () => items.forEach(item => {if (auto(item)) attemptPlay(item);else item.video.pause();});
  document.addEventListener('visibilitychange', refresh, {signal});
  media.addEventListener('change', refresh, {signal});
  document.addEventListener('shopify:section:unload', event => {
    if (event.target === root || event.target.contains(root)) {observer.disconnect();items.forEach(item => item.video.pause());lifecycle.abort();}
  }, {signal});
 };
 const init = scope => {
   if (scope.matches?.('[data-nss]')) initRoot(scope);
   scope.querySelectorAll('[data-nss]').forEach(initRoot);
 };
 document.addEventListener('shopify:section:load', event => init(event.target));
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
 else init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
	const productRecommendationsSlider = () => {
		$(document).ready(function () {
			$('.js-product-recommendations').each(function (index, parent) {
				let parentId = `#${$(parent).attr('id')}`;

				let carousel = document
					.querySelector(parentId)
					.querySelector(`.js-swiper-product-recommendations`);

				let scrollBar = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-swiper-scrollbar`);

				let prev = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-arrow-prev`);

				let next = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-arrow-next`);

				let swiperCarousel = new Swiper(carousel, {
					slidesPerView: 3,
					spaceBetween: 8,
					scrollbar: {
						el: scrollBar,
						draggable: true,
					},
					navigation: {
						prevEl: prev,
						nextEl: next,
					},
					breakpoints: {
						0: { slidesPerView: 1 },
						920: { slidesPerView: 2 },
						1100: { slidesPerView: 3 },
						1200: { slidesPerView: 2 },
						1300: { slidesPerView: 3 },
						1500: { slidesPerView: 3 },
						1800: { slidesPerView: 3 },
					},
				});

				if (
					$('.js-product-recommendations-arrow-prev').hasClass(
						'swiper-button-lock'
					) ||
					$('.js-product-recommendations-arrow-next').hasClass(
						'swiper-button-lock'
					)
				) {
					$('.nav-tools').css('display', 'none');
				}
			});
		});
	};

	class ProductRecommendations2 extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations2'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
							productRecommendationsSlider();
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations2', ProductRecommendations2);

	document.addEventListener('shopify:section:load', function () {
		productRecommendationsSlider();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-product-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('video-product-stories')) return;
  class VideoProductStories extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect(); this.resize?.disconnect();
      this.cardAnimations?.forEach(animation => animation.cancel());
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-vps-slide]')];
      if (!this.slides.length) return;
      this.index = 0;
      this.inView = false;
      this.playButton = this.querySelector('[data-vps-play]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.slides.forEach(slide => {
        slide.cardsRevealed = false;
        const video = slide.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.loop = false;
        const poster = slide.querySelector('[data-vps-poster]');
        if (poster) video.poster = poster.content.textContent.trim();
        video.addEventListener('play', () => { this.continuePlayback = true; this.sync(); }, options);
        video.addEventListener('playing', () => {
          if (this.activeVideo() === video && !slide.cardsRevealed) this.revealCards(slide);
        }, options);
        video.addEventListener('ended', () => {
          if (this.activeVideo() === video) this.advanceVideo();
        }, options);
        video.addEventListener('pause', () => this.sync(), options);
        video.addEventListener('error', () => this.sync(), options);
      });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-vps-prev]')) this.select(this.index - 1);
        if (event.target.closest('[data-vps-next]')) this.select(this.index + 1);
        const video = this.activeVideo();
        if (event.target.closest('[data-vps-play]') && video) {
          if (video.paused) { this.userPaused = false; this.play(video); }
          else { this.userPaused = true; video.pause(); }
        }
        if (event.target.closest('[data-vps-restart]') && video) { video.currentTime = 0; this.slides[this.index].cardsRevealed = false; this.userPaused = false; this.play(video); this.revealCards(this.slides[this.index]); }
        const direction = event.target.closest('[data-vps-products-prev]') ? -1 : event.target.closest('[data-vps-products-next]') ? 1 : 0;
        if (direction) {
          const rail = this.slides[this.index].querySelector('.vps__products');
          const card = rail.querySelector('.vps__card');
          rail.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || rail.clientWidth) + (parseFloat(getComputedStyle(rail).columnGap) || 0)), behavior: this.reduced.matches ? 'instant' : 'smooth' });
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.activeVideo()?.pause(); else this.maybePlay();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.maybePlay(); else this.activeVideo()?.pause();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(this);
      this.select(0, false);
    }
    revealCards(slide) {
      if (slide.cardsRevealed) return;
      slide.cardsRevealed = true;
      this.cardAnimations?.forEach(animation => animation.cancel());
      this.cardAnimations = [];
      if (this.reduced.matches) return;
      slide.querySelectorAll('.vps__card').forEach((card, index) => {
        if (!card.animate) return;
        this.cardAnimations.push(card.animate([
          { opacity: 0, transform: 'translateY(28px) scale(.97)' },
          { opacity: 1, transform: 'translateY(0) scale(1)' }
        ], { duration: 650, delay: 100 + Math.min(index, 4) * 100, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }));
      });
    }
    advanceVideo() {
      // Skip empty editor blocks and keep the playlist cycling after the final video.
      for (let step = 1; step <= this.slides.length; step++) {
        const next = (this.index + step) % this.slides.length;
        const video = this.slides[next].querySelector('video');
        if (!video) continue;
        this.continuePlayback = true;
        this.userPaused = false;
        if (next === this.index) { video.currentTime = 0; this.slides[next].cardsRevealed = false; }
        this.select(next);
        // The previous video was already playing: continue even when initial autoplay is off.
        if (this.inView && !document.hidden) this.play(video);
        return;
      }
    }
    activeVideo() { return this.slides[this.index]?.querySelector('video'); }
    play(video) { const attempt = video.play(); if (attempt) attempt.catch(() => this.sync()); }
    maybePlay() {
      if ((this.dataset.autoplay === 'true' || this.continuePlayback) && this.inView && !document.hidden && !this.reduced.matches && !this.userPaused) {
        const video = this.activeVideo(); if (video) this.play(video);
      }
    }
    select(index, animate = true) {
      const next = (index + this.slides.length) % this.slides.length;
      const changed = next !== this.index;
      this.slides.forEach((slide, i) => {
        if (i !== next) slide.querySelector('video')?.pause();
        slide.hidden = i !== next;
        slide.inert = i !== next;
      });
      this.index = next;
      if (changed) {
        this.userPaused = false;
        this.cardAnimations?.forEach(animation => animation.cancel());
        this.slides[next].cardsRevealed = false;
        const nextVideo = this.activeVideo();
        if (nextVideo) nextVideo.currentTime = 0;
        this.slides[next].querySelector('.vps__products').scrollLeft = 0;
      }
      const slide = this.slides[next];
      if (animate && changed && !this.reduced.matches && slide.animate) {
        this.transition?.cancel();
        this.transition = slide.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
      }
      const counter = this.querySelector('[data-vps-index]');
      if (counter) counter.textContent = next + 1;
      this.sync(); this.maybePlay();
    }
    sync() {
      const video = this.activeVideo();
      this.playButton.hidden = !video;
      const playing = video && !video.paused;
      this.playButton.classList.toggle('is-playing', !!playing);
      this.playButton.setAttribute('aria-label', playing ? this.playButton.dataset.pauseLabel : this.playButton.dataset.playLabel);
      const rail = this.slides[this.index].querySelector('.vps__products');
      const cards = [...rail.querySelectorAll('.vps__card')];
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const totalWidth = cards.reduce((sum, card) => sum + card.offsetWidth, 0) + Math.max(0, cards.length - 1) * gap;
      rail.classList.toggle('is-centered', cards.length > 0 && cards.length <= 2 && totalWidth <= rail.clientWidth + 1);
      this.querySelector('[data-vps-product-nav]').hidden = totalWidth <= rail.clientWidth + 2;
    }
    disconnectedCallback() {
      this.cardAnimations?.forEach(animation => animation.cancel());
      this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.transition?.cancel();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  }
  const register = () => { if (!customElements.get('video-product-stories')) customElements.define('video-product-stories', VideoProductStories); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', register, { once: true }); else register();
})();

  } catch(e) { console.error(e); }
})();
})();
